(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82],{

/***/ 6356:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[year]/[month]/[day]/[slug]",
      function () {
        return __webpack_require__(3823);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(689);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6299);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var components_buttons_cta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3576);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8492);
/* harmony import */ var components_portableText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8845);
/* harmony import */ var components_typography_heading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9852);
/* harmony import */ var components_typography_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(829);
/* harmony import */ var utilities_blockText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9700);
/* harmony import */ var utilities_blockText__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(utilities_blockText__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var components_petition_shareblock__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6860);
/* harmony import */ var utilities_propTypes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4010);
/* harmony import */ var _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7148);
/* harmony import */ var _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__);














var UPDATED_MIN_TIME_HOURS = 12; // Give a little buffer in case we make small edits after publishing.
var BlockText = function(param) {
    var blocks = param.blocks;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_portableText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        blocks: blocks
    });
};
var BlogPostDetail = function(param) {
    var post = param.post;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    if (!router.isFallback && !(post === null || post === void 0 ? void 0 : post.slug)) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
            statusCode: 404
        }));
    }
    if (router.isFallback) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: "Loading..."
        }));
    }
    var publishedAtDate = luxon__WEBPACK_IMPORTED_MODULE_11__.DateTime.fromISO(post.publishedAt);
    var lastUpdatedDate = luxon__WEBPACK_IMPORTED_MODULE_11__.DateTime.fromISO(post.lastUpdated);
    var wasUpdated = lastUpdatedDate.diff(publishedAtDate, 'hours') > UPDATED_MIN_TIME_HOURS;
    var createdDateFormatted = publishedAtDate.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_11__.DateTime.DATE_FULL);
    var lastUpdatedFormatted = lastUpdatedDate.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_11__.DateTime.DATE_FULL);
    var descriptionPlainText = (0,utilities_blockText__WEBPACK_IMPORTED_MODULE_8__.toPlainText)(post.description);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: post.title,
        dataType: components_layout__WEBPACK_IMPORTED_MODULE_4__/* .DATA_TYPES.blog */ .D.blog,
        description: descriptionPlainText,
        keywords: post.tags,
        image: post.mainImage.asset.url,
        imageAltText: post.mainImage.alt,
        publishedOn: post.publishedAt,
        updatedOn: wasUpdated ? post.lastUpdated : null,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__.blogPost,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        as: "span",
                        className: _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__.postDate,
                        children: [
                            "Published ",
                            createdDateFormatted
                        ]
                    }),
                    wasUpdated ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        as: "span",
                        className: _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__.postDate,
                        children: [
                            "\xa0/ Updated ",
                            lastUpdatedFormatted
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_heading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        as: "h1",
                        size: "h1",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__.description,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockText, {
                            blocks: post.description
                        })
                    }),
                    post.authors && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__.author,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                children: "by"
                            }),
                            " ",
                            post.authors.map(function(a) {
                                return a.name;
                            }).join(', ')
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_petition_shareblock__WEBPACK_IMPORTED_MODULE_9__/* .ShareBlock */ .T, {
                        pathname: router.asPath,
                        text: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__.postBody,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockText, {
                            blocks: post.body
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: _blog_post_module_scss__WEBPACK_IMPORTED_MODULE_12__.ctaBlock,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_buttons_cta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    keyword: post.featuredKeyword
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPostDetail);
BlockText.propTypes = {
    blocks: prop_types__WEBPACK_IMPORTED_MODULE_13___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_13___default().shape({}))
};
BlogPostDetail.propTypes = utilities_propTypes__WEBPACK_IMPORTED_MODULE_10__/* .BlogPostDetailType */ .T7;


/***/ }),

/***/ 7148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"blog-post_blogPost__8XRED","description":"blog-post_description__Mw4PE","postBody":"blog-post_postBody__G3g9q","author":"blog-post_author__i5F9j","postDate":"blog-post_postDate__EqMPa","ctaBlock":"blog-post_ctaBlock__ho2Qe"};

/***/ }),

/***/ 689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2918)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [569,193,498,761,465,323,531,732,122,774,888,179], function() { return __webpack_exec__(6356); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);